export default {
  PATTERN_PASSWORD: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[-_\s:;,.|{}[\]=+`~\\/?!@#$%^&*()<>"']).{8,255}$/,
  PATTERN_NOT_NUMBER: /[^0-9]+/g,
  PATTERN_NUMBER: /^\d+$/,
  PATTERN_EMAIL: /^[a-zA-Z0-9?^_'{|}~-]+(?:\.[a-zA-Z0-9.*+=?^_'{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}$/g,
};
